import CryptoJS from "crypto-js";

const k = "8080808080808080";
const s = 16;

export default {
  computeHash: function computeHash(str, salt) {
    let result = new Object();
    let randomSalt = '';
    if (salt == undefined || salt == null || salt.length == 0) {
      salt = CryptoJS.lib.WordArray.random(64 / 8).toString();
    }
    else {
      randomSalt = CryptoJS.lib.WordArray.random(64 / 8).toString();
    }
    result.salt = salt;
    result.randomSalt = randomSalt;

    let hashData = str + salt;
    salt = CryptoJS.enc.Utf8.parse(salt);
    let pwd = CryptoJS.SHA512(hashData);
    let hashWithSalt = ''
    hashWithSalt = pwd.concat(salt);
    pwd = CryptoJS.enc.Base64.stringify(hashWithSalt);
    if (randomSalt.length > 0) {
      let randomHashData = pwd + randomSalt;
      pwd = CryptoJS.SHA512(randomHashData);
      randomSalt = CryptoJS.enc.Utf8.parse(randomSalt);
      hashWithSalt = pwd.concat(randomSalt);
      pwd = CryptoJS.enc.Base64.stringify(hashWithSalt);  
    }
    
    result.hash = pwd.toString();
    return result;
  },
  encryptAES: function encryptAES(str) {
    let result = "";
    let key = CryptoJS.enc.Utf8.parse(k);
    let iv = CryptoJS.enc.Utf8.parse(k);
    result = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(str), key, {
      keySize: s,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
    return result;
  },
  decryptAES: function decryptAES(str) {
    let result = "";
    let key = CryptoJS.enc.Utf8.parse(k);
    let iv = CryptoJS.enc.Utf8.parse(k);
    result = CryptoJS.AES.decrypt(str, key, {
      keySize: s,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return result;
  }
};



// WEBPACK FOOTER //
// ./src/router/encryption.js